// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Equipment } from './equipment';
import { EquipmentAttachmentType } from './equipment-attachment-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class EquipmentAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  equipmentAttachmentId: number;
  applicationUserId: string;
  attName: string;
  attRef: string;
  attachmentUrl: string;
  createdOn: Date;
  equipmentAttachmentTypeId: number;
  equipmentId: number;
  modifiedOn: Date;
  applicationUser: ApplicationUser;
  equipment: Equipment;
  equipmentAttachmentType: EquipmentAttachmentType;
}

